// extracted by mini-css-extract-plugin
export default {"wrapper":"text-field_wrapper__B5fe0","textField":"text-field_textField__l7TAJ","hasLabelText":"text-field_hasLabelText__MIqCv","labelText":"text-field_labelText__Z0-b3"};